import React from 'react';
import { companyImage } from '@/utils/common/env.constants';
import { useRouter } from 'next/router';
import ProjectContent from './ProjectContent';

type Props = {
  galleryProjects?: {
    title: string;
    img: string;
    desc: string;
  }[];
};

const Layout2 = ({ galleryProjects }: Props) => {
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  return (
    <div
      className={`${
        isDashboard ? 'px-1' : ''
      } w-full grid-cols-3 gap-5 max-h-[451px] hidden large:!grid`}
    >
      {galleryProjects?.map((project) => (
        <div key={project.title} className="rounded-xl overflow-hidden flex shadow-light">
          <img
            src={`${companyImage}/project_gallery/${project?.img}`}
            alt=""
            className="h-full w-[40%] object-cover"
          />
          <ProjectContent projectContent={project} />
        </div>
      ))}
    </div>
  );
};

export default Layout2;
